<sdc-bo-dialog
  headerTitle="Create new Upgrade"
  [styleClass]="['variant-prominent-title']"
  [attr.data-cy]="'upgrade-create-modal'">
  <div class="content-wrapper">
    <div class="mt-6">
      <div class="input-line">
        <div>
          <span><b>Name</b> <span class="mandatory-asterisk">*</span></span>
        </div>
        <div>
          <input
            [attr.data-cy]="'upgrade-create-modal-name-input'"
            type="text"
            [(ngModel)]="item.name"
            [class.invalid-input]="hashValidator.name" />
          @if (hashValidator.name) {
            <span class="text-[80%] error-color">This entry is mandatory</span>
          }
        </div>
      </div>
      <div class="input-line">
        <div>
          <span
            ><b>Description</b> <span class="mandatory-asterisk">*</span></span
          >
        </div>
        <div>
          <textarea
            [attr.data-cy]="'upgrade-create-modal-description-input'"
            [(ngModel)]="item.description"
            [class.invalid-input]="hashValidator.description"></textarea>
          @if (hashValidator.description) {
            <span class="text-[80%] error-color">This entry is mandatory</span>
          }
        </div>
      </div>
      <div class="input-line">
        <div>
          <span><b>Goal</b> <span class="mandatory-asterisk">*</span></span>
        </div>
        <div>
          <input
            type="number"
            [(ngModel)]="item.goal"
            [class.invalid-input]="hashValidator.goal" />
          @if (hashValidator.goal) {
            <span class="text-[80%] error-color">This entry is invalid</span>
          }
        </div>
      </div>
      <div class="input-line">
        <div>
          <span
            ><b>Min. Seats to show</b>
            <span class="mandatory-asterisk">*</span></span
          >
        </div>
        <div>
          <input type="number" [(ngModel)]="item.minSeatsToShow" />
          @if (hashValidator.minSeatsToShow) {
            <span class="text-[80%] error-color">This entry is invalid</span>
          }
        </div>
      </div>
      <div class="input-line">
        <div>
          <span>
            <b>Visibility</b>
          </span>
        </div>
        <div>
          <select [(ngModel)]="item.active">
            <option value="true">On</option>
            <option value="false">Off</option>
          </select>
        </div>
      </div>
    </div>
    <div class="ms-6 mt-6">
      <div class="toggle-group mt-0 mb-4 px-4 py-2">
        <div class="toggle-wrapper">
          <input
            id="select-all-events-upgrade-create"
            type="checkbox"
            [(ngModel)]="isAllEventsSelected"
            (change)="onSelectAllEventsChange($event)" />
          <label for="select-all-events-upgrade-create">
            Select all events
          </label>
        </div>
      </div>
      <gs-event-selector
        [ngModel]="selectedEventIds"
        [ngModelOptions]="{ standalone: true }"
        (ngModelChange)="onEventSelectionChange($event)"
        (selectionMeta)="onEventSelectionMeta($event)"></gs-event-selector>
    </div>
  </div>
  <ng-container sdc-bo-dialog-footer>
    <sdc-button
      [attr.data-cy]="'upgrade-create-modal-cancel-button'"
      variant="secondary"
      (onClick)="onDismiss('cancel')">
      Cancel
    </sdc-button>
    <sdc-button
      [attr.data-cy]="'upgrade-create-modal-confirm-button'"
      variant="primary"
      (onClick)="onConfirm()">
      Save & Publish
    </sdc-button>
  </ng-container>
</sdc-bo-dialog>
